import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY } from "../i18n";
import { trackLanguageToggle } from "../utils/ga4Events";

function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const isTamil = i18n.language === "ta";

  const changeLanguage = (language) => {
    const fromLang = localStorage.getItem(LANGUAGE_STORAGE_KEY) || "en";
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    i18n.changeLanguage(language);
    trackLanguageToggle({ from_lang: fromLang, to_lang: language, current_screen: window.location.pathname });
  };

  return (
    <div className={`kuran-lang-switch ${className}`.trim()}>
      <button
        type="button"
        className={`kuran-lang-switch__pill ${isTamil ? "is-tm" : ""}`}
        onClick={() => changeLanguage(isTamil ? "en" : "ta")}
        aria-label="Toggle language"
      >
        <span className="kuran-lang-switch__option kuran-lang-switch__option--tm">TM</span>
        <span className="kuran-lang-switch__option kuran-lang-switch__option--en">EN</span>
        <span className="kuran-lang-switch__slider" />
      </button>
    </div>
  );
}

export default LanguageToggle;
